export enum UserRoles {
    Admin = 'admin',
    NetworkPartner = 'network_partner',
    PubDev = 'pubdev',
    Seller = 'seller',
    DocsEditor = 'docs_editor',
    LocaleWriter = 'locale_writer',
}
